import { render, staticRenderFns } from "./entity.vue?vue&type=template&id=1d063eb1&scoped=true"
import script from "./entity.vue?vue&type=script&lang=js"
export * from "./entity.vue?vue&type=script&lang=js"
import style0 from "./entity.vue?vue&type=style&index=0&id=1d063eb1&scoped=true&lang=css"
import style1 from "./entity.vue?vue&type=style&index=1&id=1d063eb1&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d063eb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d063eb1')) {
      api.createRecord('1d063eb1', component.options)
    } else {
      api.reload('1d063eb1', component.options)
    }
    module.hot.accept("./entity.vue?vue&type=template&id=1d063eb1&scoped=true", function () {
      api.rerender('1d063eb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/groupReporting/entity.vue"
export default component.exports